import { Link } from "react-router-dom";

/*
  Shared breadcrumb bar for the workbook flow. Cream background, muted text,
  Plus Jakarta Sans, matching the catalog and detail style.

  Props:
    items     array of { label, to }. The last item is the current page and
              should have no `to` (rendered as muted navy, not a link).
    backTo    optional path. When present a small "Back" link with a left arrow
              renders at the start of the bar.
    backLabel optional label for the back link. Defaults to "Back".

  No em or en dashes.
*/

const CREAM = "#F5F2EC";
const BLUE = "#2563EB";
const NAVY_MUTED = "#1e2a3a";
const SEP = "#b8ad9e";

export default function WorkbookBreadcrumb({ items = [], backTo, backLabel = "Back" }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 12,
        background: CREAM,
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
        fontSize: 13,
        fontWeight: 500,
        padding: "10px 0",
      }}
    >
      {backTo && (
        <>
          <Link
            to={backTo}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              color: BLUE,
              textDecoration: "none",
            }}
          >
            <span style={{ fontSize: 15, lineHeight: 1 }}>&larr;</span>
            {backLabel}
          </Link>
          <span style={{ color: SEP }}>&middot;</span>
        </>
      )}

      <nav style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
              {item.to && !isLast ? (
                <Link to={item.to} style={{ color: BLUE, textDecoration: "none" }}>
                  {item.label}
                </Link>
              ) : (
                <span style={{ color: NAVY_MUTED }}>{item.label}</span>
              )}
              {!isLast && <span style={{ color: SEP }}>/</span>}
            </span>
          );
        })}
      </nav>
    </div>
  );
}
